import { useEffect, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { validatePasswordRules } from '@/modules/auth/components/PasswordWithTooltip/hooks/usePasswordRules';

import { TitleMap, titleTranslation } from './utils';

const useResetPassword = () => {
  const { t } = useTranslation();
  const [passwords, setPasswords] = useState<Record<keyof typeof TitleMap, string>>({
    [TitleMap.currentPassword]: '',
    [TitleMap.newPassword]: '',
    [TitleMap.confirmPassword]: '',
  });
  const [errors, setErrors] = useState<Record<keyof typeof TitleMap, string>>({
    [TitleMap.currentPassword]: '',
    [TitleMap.newPassword]: '',
    [TitleMap.confirmPassword]: '',
  });
  const [isDirty, setIsDirty] = useState<Record<keyof typeof TitleMap, boolean>>({
    [TitleMap.currentPassword]: false,
    [TitleMap.newPassword]: false,
    [TitleMap.confirmPassword]: false,
  });

  useEffect(() => {
    let error = {
      [TitleMap.currentPassword]: '',
      [TitleMap.newPassword]: '',
      [TitleMap.confirmPassword]: '',
    };

    Object.entries(passwords).forEach(([key, value]) => {
      if (!value) {
        error = {
          ...error,
          [key]: t('Auth:passwordEmptyError', {
            field: t(titleTranslation[key as keyof typeof passwords]),
          }),
        };
      } else if (key === TitleMap.newPassword) {
        const { isFailing } = validatePasswordRules(value);
        if (isFailing) {
          error = {
            ...error,
            [key]: t('Auth:error.weakPasswordStrength'),
          };
        }
      }
    });

    if (passwords.newPassword !== passwords.confirmPassword && !error.confirmPassword) {
      error = {
        ...error,
        [TitleMap.confirmPassword]: t('Auth:mustMatch'),
      };
    }

    setErrors(error);
  }, [passwords, t]);

  return { errors, isDirty, passwords, setErrors, setIsDirty, setPasswords };
};

export default useResetPassword;
